import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UATConstants } from 'src/Common/Models/UATConstants';
import { IControlListItem, ISavePartnerOneInfo } from 'src/Common/RTK/interface/ViewFolder';
import {
  MANAGE_ACTION_API_CONSTANTS,
  MANAGE_ACTION_CONSTANTS,
} from 'src/manageAction/utils/manageActionConstants';

export const GPSActionApi = createApi({
  reducerPath: 'GPSActionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: UATConstants.WebApiUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_API);
      const coreAPIToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_CORE_API);
      const graphToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_GRAPH);

      if (token && graphToken && coreAPIToken) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Coreapitoken', coreAPIToken);
        headers.set('Graphtoken', graphToken);
      }
      return headers;
    },
  }),
  tagTypes: ['getControlList', 'getPartnerList'], // Define the tags for this API
  endpoints: (builder) => ({
    getTaskList: builder.query<any[], string>({
      query: (actionId) => ({
        method: 'GET',
        url: `${MANAGE_ACTION_API_CONSTANTS.GetTaskList}${actionId}`,
      }),
    }),
    getControlList: builder.query<any[], string>({
      query: (actionId) => ({
        method: 'GET',
        url: `${MANAGE_ACTION_API_CONSTANTS.GetControlList}${actionId}`,
      }),
      providesTags: ['getControlList'],
    }),
    SaveControlList: builder.mutation<string[], IControlListItem[]>({
      query: (controlList) => ({
        method: 'POST',
        url: `${MANAGE_ACTION_API_CONSTANTS.SaveControlList}${controlList[0].actionId}`,
        body: controlList,
      }),
      invalidatesTags: ['getControlList'],
    }),
    getPartnerList: builder.query<any[], string>({
      query: (actionId) => ({
        method: 'GET',
        url: `${MANAGE_ACTION_API_CONSTANTS.GetPartnerList}${actionId}`,
      }),
      providesTags: ['getPartnerList'],
    }),
    SavePartnerList: builder.mutation<string[], ISavePartnerOneInfo[]>({
      query: (partnerList) => ({
        method: 'POST',
        url: `${MANAGE_ACTION_API_CONSTANTS.SavePartnerList}`,
        body: partnerList,
      }),
      invalidatesTags: ['getPartnerList'],
    }),
    getAMMMilestoneSnapshot: builder.query<any[], string>({
      query: (actionId) => ({
        method: 'GET',
        url: `${MANAGE_ACTION_API_CONSTANTS.GetAMMMilestoneSnapshot}${actionId}`,
      }),
    }),
    getUsersTable: builder.mutation<
      any,
      {
        DisplayName: string;
      }
    >({
      query: (body) => ({
        method: 'POST',
        url: MANAGE_ACTION_API_CONSTANTS.GetUsersTable,
        body,
      }),
    }),
    getUsersAndGroups: builder.mutation<
      any,
      {
        DisplayName: string;
      }
    >({
      query: (body) => ({
        method: 'POST',
        url: MANAGE_ACTION_API_CONSTANTS.GetUsersAndGroups,
        body,
      }),
    }),
  }),
});
